import { fabric } from "fabric";
import DEFINE from "../define";
import ToolBase from "../basic";

import EventBus from "../../event_bus";

const IMG_WIDTH = 50;
const TXT_SIZE = 20;
const SPACE = 10;
const WEB_LINK_URL = ""
const WEB_LINK_NAME = ""
const TEXT_TIP_IMAGE = "./image/sticky/sticky.svg";

export default class sticky extends ToolBase {

    name = DEFINE.TOOLS.STICKY;

    point = {
        x: 0,
        y: 0
    }
    stickyTitle = "";
    defaultMessage = "";
    /**
     *
     * current opened sticky
     * @memberof sticky
     */
    currentSticky = null;
    /**
     *
     * is current sticky moving
     * @memberof sticky
     */
    moving = false;

    constructor(parent) {
        super(parent);
    }

    recover(object) {
        let group = object;

        group.set({
            hasControls: false,
            subTargetCheck: true,
            hasBorders: false
        });

        this.registerEvent(object);
    }

    mouseDown(o) {
        let pointer = this.canvas.getPointer(o.e)
        this.parent.proxy.changeTool(null);

        this.point = {
            x: pointer.x,
            y: pointer.y
        }

        this.createSticky(pointer.x, pointer.y);
    }

    createSticky(x, y) {
        const txt = new fabric.Text(this.stickyTitle, {
            fontSize: 20
        });

        fabric.Image.fromURL(TEXT_TIP_IMAGE, (image) => {
            const icon = image;
            icon.scaleToWidth(50);
            icon.setCoords();

            const group = new fabric.Group([icon, txt], {
                toolType: this.name,
                tag: DEFINE.TAG.STICKY + new Date().getTime(),
                data: {
                    title: this.stickyTitle,
                    message: this.defaultMessage
                },
                width: 100,
                height: 73.6,
                hasControls: false,
                subTargetCheck: true,
                hasBorders: false,
                left: x - 50,
                top: y - 18.4
            });

            txt.set({
                left: -txt.getScaledWidth() * 0.5,
                top: txt.getScaledHeight() * 0.5
            });

            icon.set({
                left: 0,
                top: -group.getScaledHeight() * 0.5,
                originX: "center"
            });

            this.registerEvent(group);

            this.canvas.add(group);
            this.canvas.renderAll();

            this.parent.addHistory();
        })
    }

    registerEvent(group) {
        const self = this;
        group.on("mousedown", (e) => {
            self.currentSticky = group;
            self.moving = false;
        });
        group.on("moving", (e) => {
            self.moving = true;
            self.currentBoard = null;
            self.canvas.renderAll();
        });
        group.on("mouseup", (e) => {
            if (e.target == self.currentSticky && self.moving == false) {
                self.openAndSetSticky(group);
            }
        });
    }

    openAndSetSticky(group) {
        EventBus.getInstance().emit("sendSticky", {
            sticky: group,
            title: group.data.title,
            message: group.data.message,
            stickyTool: this
        });
    }

    updateCurrentSticky(newTitle, newMessage) {
        this.currentSticky.data.title = newTitle;
        this.currentSticky.data.message = newMessage;

        const objects = this.currentSticky.getObjects("text");
        objects[0].set({
            "text": newTitle
        });
        objects[0].set({
            left: -objects[0].getScaledWidth() * 0.5
        })

        this.currentSticky.set({
            width: objects[0].getScaledWidth() > 100 ? objects[0].getScaledWidth() : 100
        })

        this.canvas.renderAll();
        this.parent.addHistory();
    }

    deleteCurrentSticky() {
        this.canvas.remove(this.currentSticky);

        this.canvas.renderAll();
        this.parent.addHistory();
    }
}